import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Page1 = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  const secondpage = () => {
   
  };


  const location = useLocation();
  const binaryCiphertext = location.state.binaryCiphertext;
  const bytes = location.state.bytes;
  
  // let dupInputValue = inputValue;

  function groupTo64Bytes(groupedArray) {
    
    const bytesArray = [];
    for (let i = 0; i < 64; i += 8) {
      const byte = groupedArray.slice(i, i + 8);
      bytesArray.push(byte);
    }

    return bytesArray;
  }
  let binaryInputValue = groupTo64Bytes(binaryCiphertext);

  console.log(binaryInputValue)
  console.log(bytes)
  // let dupKeyValue = KeyValue;
  // let hexKeyValue = "";
  // let binaryKeyValue = "";

  // if (dupKeyValue.length < 8) {
  //   while (dupKeyValue.length < 8) {
  //     dupKeyValue += "\0";
  //   }
  // }

  // for (let i = 0; i < dupKeyValue.length; i++) {
  //   const hex = dupKeyValue
  //     .charCodeAt(i)
  //     .toString(16)
  //     .toUpperCase()
  //     .concat(",");
  //   const bin = dupKeyValue.charCodeAt(i).toString(2).concat(",");
  //   hexKeyValue += hex.padStart(2, "0");
  //   hexKeyValue = hexKeyValue.split(",");
  //   binaryKeyValue += bin.padStart(9, "0");
  //   binaryKeyValue = binaryKeyValue.split(",");
  // }

  // binaryKeyValue.pop();
  // hexKeyValue.pop();

  // let binaryKeyValue56 = "";
  // for (let i = 0; i < binaryKeyValue.length; i++) {
  //   console.log(binaryKeyValue[i].slice(0, 7));
  //   binaryKeyValue56 += binaryKeyValue[i].slice(0, 7) + ",";
  // }
  // binaryKeyValue56 = binaryKeyValue56.split(",");
  // binaryKeyValue56.pop();

  // if (dupInputValue.length < 8) {
  //   while (dupInputValue.length < 8) {
  //     dupInputValue += "\0";
  //   }
  // }

  // for (let i = 0; i < dupInputValue.length; i++) {
  //   const hex = dupInputValue
  //     .charCodeAt(i)
  //     .toString(16)
  //     .toUpperCase()
  //     .concat(",");
  //   const bin = dupInputValue.charCodeAt(i).toString(2).concat(",");
  //   binaryInputValue += bin.padStart(9, "0");
  //   binaryInputValue = binaryInputValue.split(",");
  // }

  // binaryInputValue.pop();
  // console.log(binaryInputValue);
  // function initialPermutation(plaintext) {
  //   // Define the initial permutation table (IP)
  //   const ipTable = [
  //     58, 50, 42, 34, 26, 18, 10, 2,
  //     60, 52, 44, 36, 28, 20, 12, 4,
  //     62, 54, 46, 38, 30, 22, 14, 6,
  //     64, 56, 48, 40, 32, 24, 16, 8,
  //     57, 49, 41, 33, 25, 17, 9, 1,
  //     59, 51, 43, 35, 27, 19, 11, 3,
  //     61, 53, 45, 37, 29, 21, 13, 5,
  //     63, 55, 47, 39, 31, 23, 15, 7,
  //   ];
  
  //   // Check if the plaintext array is valid
  //   if (plaintext.length !== 8 || plaintext.some(elem => elem.length !== 8)) {
  //     throw new Error('Plaintext array must contain 8 elements, each with 8 bits.');
  //   }
  
  //   // Initialize the result array
  //   const result = [];
  
  //   // Convert the plaintext array to a single binary string
  //   const binaryPlaintext = plaintext.join('');
  
  //   // Apply the initial permutation
  //   for (let i = 0; i < 64; i++) {
  //     const targetBitIndex = ipTable[i] - 1;
  //     result.push(binaryPlaintext.charAt(targetBitIndex));
  //   }
  
  //   return result;
  // }
  
  // function groupToBytes(groupedArray) {
  //   if (groupedArray.length !== 64 || groupedArray.some(elem => elem.length !== 1)) {
  //     throw new Error('Input array must contain 64 elements, each with 1 bit.');
  //   }
  
  //   const bytesArray = [];
  //   for (let i = 0; i < 64; i += 8) {
  //     const byte = groupedArray.slice(i, i + 8).join('');
  //     bytesArray.push(byte);
  //   }
  
  //   return bytesArray;
  // }

  // // Example usage:
  // const initialPermuted = initialPermutation(binaryInputValue);
  // const bytes = groupToBytes(initialPermuted);  

  // console.log(binaryInputValue);

  // const splitInto28 = (array) => {
  //   let binaryString = arrayToString(array);

  //   const OrderForC = [
  //     57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43,
  //     35, 27, 19, 11, 3, 60, 52, 44, 36,
  //   ];

  //   const OrderForD = [
  //     63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45,
  //     37, 29, 21, 13, 5, 28, 20, 12, 4,
  //   ];

  //   let binary28bit_c = [];
  //   for (let i = 0; i < 28; i++) {
  //     binary28bit_c[i] = binaryString[OrderForC[i] - 1];
  //   }

  //   let binary28bit_d = [];
  //   for (let i = 0; i < 28; i++) {
  //     binary28bit_d[i] = binaryString[OrderForD[i] - 1];
  //   }

  //   return [binary28bit_c, binary28bit_d];
  // };

  // const arrayToString = (array) => {
  //   let string = "";
  //   for (let i = 0; i < array.length; i++) {
  //     string += array[i];
  //   }
  //   return string;
  // };

  // const stringToArray = (string) => {
  //   const chunks = [];
  //   for (let i = 0; i < 28; i += 7) {
  //     chunks.push(string.substring(i, i + 7));
  //   }
  //   return chunks;
  // };

  // const leftShift = (round, array) => {
  //   let c = array[0];
  //   let d = array[1];
  //   let shiftedCD = [];
  //   if (round === 1 || round === 2 || round === 9 || round === 16) {
  //     let shiftAmount = 1;
  //     let shiftedC =
  //       arrayToString(c).slice(shiftAmount) +
  //       arrayToString(c).slice(0, shiftAmount);
  //     let shiftedD =
  //       arrayToString(d).slice(shiftAmount) +
  //       arrayToString(d).slice(0, shiftAmount);
  //     shiftedCD.push(stringToArray(shiftedC), stringToArray(shiftedD));
  //     return shiftedCD;
  //   } else {
  //     let shiftAmount = 2;
  //     let shiftedC =
  //       arrayToString(c).slice(shiftAmount) +
  //       arrayToString(c).slice(0, shiftAmount);
  //     let shiftedD =
  //       arrayToString(d).slice(shiftAmount) +
  //       arrayToString(d).slice(0, shiftAmount);
  //     shiftedCD.push(stringToArray(shiftedC), stringToArray(shiftedD));
  //     return shiftedCD;
  //   }
  // };

  // const compPermute = (array) => {
  //   let compPermuteArray = [];
  //   let bigString = arrayToString(array[0].concat(array[1]));
  //   const compPermuteOrder = [
  //     14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7,
  //     27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39,
  //     56, 34, 53, 46, 42, 50, 36, 29, 32,
  //   ];
  //   for (let i = 0; i < 48; i++) {
  //     compPermuteArray[i] = bigString[compPermuteOrder[i] - 1];
  //   }
  //   return compPermuteArray;
  // };

  // const crctFormetForSplited = (array) => {
  //   const outputArray = [];
  //   for (const str of array) {
  //     for (const char of str) {
  //       outputArray.push(char);
  //     }
  //   }
  //   return outputArray;
  // };

  // const compute = (binaryKeyValue, round) => {
  //   if (round === 1) {
  //     let splitedArray = splitInto28(binaryKeyValue);

  //     let shiftedArray = leftShift(round, splitedArray);

  //     let compPermuteArray = compPermute(shiftedArray);

  //     return [splitedArray, shiftedArray, compPermuteArray];
  //   } else {
  //     let splitedArray = [
  //       crctFormetForSplited(binaryKeyValue[0]),
  //       crctFormetForSplited(binaryKeyValue[1]),
  //     ];

  //     let shiftedArray = leftShift(round, splitedArray);
  //     //console.log(shiftedArray);
  //     let compPermuteArray = compPermute(shiftedArray);
  //     //console.log(compPermuteArray);
  //     return [splitedArray, shiftedArray, compPermuteArray];
  //   }
  // };

  // const keyGeneration = () => {
  //   let allResults = [];
  //   let currInput = binaryKeyValue;

  //   for (let round = 1; round < 17; round++) {
  //     let oneRoundResult = compute(currInput, round);
  //     //console.log(compute(currInput , round));
  //     currInput = oneRoundResult[1];
  //     allResults.push(oneRoundResult);
  //   }
  //   return allResults;
  // };

  // let allResults = keyGeneration();

  // console.log(allResults);

  return (
    <>
<div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>This page is all about Initial Permutation step of the DES algorithm.<br></br><br></br>
      An initial permutation is required only once at the starting of the decryption process.
      This initial permutation is a phase in the transposition procedure.
      </p>
    </div>
      <div className="input-container">
        <div className="flex flex-col items-center">
        
          
          <div className="flex flex-row">
            <div className="flex flex-col">
              <p>64 bit binary Value: </p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {binaryInputValue[0]}
                <br></br>
                {binaryInputValue[1]}
                <br></br>
                {binaryInputValue[2]}
                <br></br>
                {binaryInputValue[3]}
                <br></br>
                {binaryInputValue[4]}
                <br></br>
                {binaryInputValue[5]}
                <br></br>
                {binaryInputValue[6]}
                <br></br>
                {binaryInputValue[7]}
                <br></br>
              </div>
              
            </div>
            <div className="px-5">
           
          <p className="bg-slate-100 px-2 py-2 rounded-md">
            Entered Key value: {/*inputValue*/}
          </p>
          <br></br>
          <p>Hex Value: {/*hexInputValue*/}</p>
          <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
              <svg
                width="300"
                height="38"
                viewBox="0 0 573 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                  fill="black"
                />
              </svg>
              <br></br><br></br><br></br><br></br><br></br>
              <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
            PREVIOUS
          </div>
          <div className="next-button" onClick={secondpage}>
            NEXT
          </div>
        </div>
            </div>
            <div className="flex flex-col">
              <p>64 Bit value after IP</p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {bytes[0]}
                <br></br>
                {bytes[1]}
                <br></br>
                {bytes[2]}
                <br></br>
                {bytes[3]}
                <br></br>
                {bytes[4]}
                <br></br>
                {bytes[5]}
                <br></br>
                {bytes[6]}
                <br></br>
                {bytes[7]}
                <br></br>
              
              </div>
              
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
};

export default Page1;